
import React, { useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import classes from './StudentsMenu.module.css';
import { useSelector } from "react-redux";
import { onKeyDown } from '../../../../service';

const StudentsMenu = ({ studentsData, currentUrl }) => {

    const navigate = useNavigate();
    const { guid } = useParams();
    const { direction, texts } = useSelector(state => state.translate);

    useEffect(() => {
        if (studentsData && currentUrl) {
            if (studentsData.length > 0) {
                if (guid && studentsData.find(sd => sd.id == guid)) {
                    navigate(`${currentUrl}/${guid}`)
                }
                else {
                    navigate(`${currentUrl}/${studentsData[0].id}`)
                }
            }
            else
                navigate(`${currentUrl}/0`)
        }
    }, [currentUrl, studentsData])

    const handleCurentSubMenuItem = (id) => {
        navigate(`${currentUrl}/${id}`)
    }

    return (
        <div className={`${classes.StudentsMenu} ${classes[direction]}`}>
            {studentsData && studentsData.length > 0 ? studentsData.sort((a, b) => a.user?.firstName.localeCompare(b.user?.firstName)).map(s =>
                <div className={`${classes.StudentMenu} ${guid === s.id ? classes.Current : ``}`} key={s.id}>
                    {s.user &&
                        <div className={`${classes.StudentName}`} onClick={() => handleCurentSubMenuItem(s.id)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleCurentSubMenuItem(s.id))}>
                            <p>{s.user.firstName} {s.user.lastName} </p>
                            <p>{s.user.class}</p>
                        </div>
                    }
                </div>)
                : <div className={classes.Message}> {texts.NoStudentsFound}</div>}
        </div>
    )

}
export default StudentsMenu